setTimeout(() => {
  if (new URLSearchParams(window.location.search).get("SAHide") === "false") {
    // Remove hiding classes and attributes
    document.querySelectorAll("[samitaws-product-price]").forEach(el => {
      el.removeAttribute("samitaws-product-price");
    });
    document.querySelectorAll("[samitaws-product-main-price]").forEach(el => {
      el.removeAttribute("samitaws-product-main-price");
    });
    document.querySelectorAll(".rfq-hidden").forEach(el => {
      el.classList.remove("rfq-hidden");
    });

    // Force display
    document.querySelector(".price.price--large.price--on-sale.price--show-badge").style.cssText = "display:block !important";
    document.querySelector(".price__container").style.cssText = "display:block !important";
    document.querySelector(".price-item--sale.price-item--last").style.cssText = "display:block !important;";
  }
}, 2000); // 2000ms = 2 seconds
